import { render, staticRenderFns } from "./BidCostComponentTable.vue?vue&type=template&id=5b2ed519&"
import script from "./BidCostComponentTable.vue?vue&type=script&lang=js&"
export * from "./BidCostComponentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports